/**
 * Dictionary validation utilities
 */

// API for word validation using WordsAPI from RapidAPI
const WORDSAPI_BASE_URL = "https://wordsapiv1.p.rapidapi.com/words/";
const WORDSAPI_OPTIONS = {
  method: "GET",
  headers: {
    "x-rapidapi-key": "f2e8ac5666msh5f043c7d0cfea55p1a09fejsnb9e27442407f",
    "x-rapidapi-host": "wordsapiv1.p.rapidapi.com",
  },
};

/**
 * Check if a word is valid in the dictionary using WordsAPI
 * @param {string} word - The word to check
 * @returns {Promise<boolean>} - True if the word is valid, false otherwise
 */
export const checkWordValidity = async (word) => {
  try {
    // Build the URL with the word to check
    const url = `${WORDSAPI_BASE_URL}${word}`;

    // Create a timeout promise
    let timeoutId;
    const timeoutPromise = new Promise((resolve) => {
      timeoutId = setTimeout(() => {
        resolve({ result: true, source: "timeout" });
      }, 1000);
    });

    // Create the API request promise
    const fetchPromise = fetch(url, WORDSAPI_OPTIONS).then((response) => {
      clearTimeout(timeoutId); // Clear the timeout if API responds first
      return { result: response.ok, source: "api" };
    });

    // Race between the timeout and the API request
    const result = await Promise.race([fetchPromise, timeoutPromise]);
    return result.result;
  } catch (error) {
    console.error(`Dictionary check failed for word: "${word}":`, error);
    return true; // If there's an API error, accept the word to avoid disrupting the game
  }
};

/**
 * A fallback method that could be used if the API is not available
 * This would require storing a word list in the app
 */
export const checkWordValidityOffline = (word, wordList) => {
  // Check if the word is in the provided word list
  return wordList.includes(word.toLowerCase());
};
